import { render } from "./index.vue?vue&type=template&id=6c064c1a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6c064c1a&lang=scss"
const cssModules = {}
import style1 from "./index.vue?vue&type=style&index=1&id=6c064c1a&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__